import { RouteConfig } from "vue-router"

export const ReleasedRuleListRouteConfig: RouteConfig = {
  path: "/releasedRuleList",
  name: "ReleasedRuleList",
  component: () => import("%%/views/releasedRuleList/ReleasedRuleList.vue"),
  meta: {
    reload: false,
    authRequired: true,
  },
}
